import React from 'react';
import styled from 'styled-components';
import { NitroHeading } from 'nitro-components';

import Bookmarks from '../components/Bookmarks';
import Container from '../../../../components/layouts/Container';
import Page from '../../../../components/layouts/Page';

const Header = styled.div`
  margin: 15px 0;
`;

const BookmarksContainer = styled.div`
  max-width: 450px;
`;

/**
 * This component renders the bookmarks UI displayed within the context of a full page.
 */
export default () => (
  <Container>
    <Page header>
      <Header>
        <NitroHeading label="Bookmarks" size="1" />
      </Header>
      <BookmarksContainer>
        <Bookmarks />
      </BookmarksContainer>
    </Page>
  </Container>
);



// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/containers/BookmarksPage.js